import { render, staticRenderFns } from "./JSEditor.vue?vue&type=template&id=45a862ea&"
import script from "./JSEditor.vue?vue&type=script&lang=js&"
export * from "./JSEditor.vue?vue&type=script&lang=js&"
import style0 from "./JSEditor.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports